import { render, staticRenderFns } from "./GiftCardList.vue?vue&type=template&id=e20bef4e&scoped=true"
import script from "./GiftCardList.vue?vue&type=script&lang=js"
export * from "./GiftCardList.vue?vue&type=script&lang=js"
import style0 from "./GiftCardList.vue?vue&type=style&index=0&id=e20bef4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20bef4e",
  null
  
)

export default component.exports